import React, { useEffect, useState } from 'react';
import { Button } from 'components/ui/button';
import { cn } from 'lib/utils';

interface IProps {
  pageId?: string;
  results: number;
  prevPage: () => void;
  nextPage: () => void;
  prevKey: string | null;
  nextKey: string | null;
  className?: string;
}

const PAGE_SIZE = 25; // Default size in Sparc backend

const Pagination = ({
  pageId,
  results,
  prevPage,
  nextPage,
  prevKey,
  nextKey,
  className,
}: IProps): JSX.Element | null => {
  const [currentPage, setCurrentPage] = useState(0);

  const onPrevPage = () => {
    setCurrentPage(currentPage - 1);
    prevPage();
  };

  const onNextPage = () => {
    setCurrentPage(currentPage + 1);
    nextPage();
  };

  useEffect(() => {
    setCurrentPage(0);
  }, [pageId]);

  const resultStart = currentPage * PAGE_SIZE + 1;
  const resultEnd = Math.min((currentPage + 1) * PAGE_SIZE, results);

  return (
    <div
      className={cn(
        'flex justify-between items-center mt-5 mb-7 w-full',
        className
      )}
    >
      <div className="grow py-1.5 text-sm">
        {results > 0 && (
          <div>
            {/* For Desktop view */}
            <span className="hidden sm:inline">
              <span className="text-gray-blue-50">Viewing </span>
              {resultStart} <span className="text-gray-blue-50">to </span>
              {resultEnd} <span className="text-gray-blue-50">of </span>
              {results} <span className="text-gray-blue-50">results</span>
            </span>
            {/* For mobile view */}
            <span className="inline sm:hidden">
              {resultStart} &ndash; {resultEnd}{' '}
              <span className="text-gray-blue-50">/</span> {results}
              <span className="text-gray-blue-50"> results</span>
            </span>
          </div>
        )}
      </div>
      <div className="flex">
        <Button
          variant="secondary"
          size="sm"
          rounded={null}
          className="rounded-l rounded-r-none shadow-sm"
          onClick={onPrevPage}
          disabled={!prevKey}
        >
          Previous
        </Button>
        <Button
          variant="secondary"
          size="sm"
          rounded={null}
          className="rounded-r rounded-l-none -ml-px shadow-sm"
          onClick={onNextPage}
          disabled={!nextKey}
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default Pagination;
